import type { HelpFile } from '../../types/help'
import { SapAbapOutboundConfigCardTestIds } from '../../../testids/SapAbapOutboundConfigCardTestIds'

export const sapAbapOutboundConfigCardHelp: HelpFile = {
  docPage: '/docs/connectors/sap-abap-connector',
  texts: {
    [SapAbapOutboundConfigCardTestIds.sapAbapConfigSection]:
      'Ausgehende Provisionierung in SAP ABAP. OData V2 deckt Konfiguration und Rollenzuweisung im OData-Modus ab; der optionale RFC/BAPI-Pfad übernimmt Benutzeranlage und Rollenzuweisung über BAPI_USER_CREATE1 und BAPI_USER_ACTGRPS_ASSIGN.',
    [SapAbapOutboundConfigCardTestIds.cardTitleSapAbapConfig]: null,
    [SapAbapOutboundConfigCardTestIds.btnEditSapAbapConfig]: null,
  },
}
